import { Component, OnInit, ViewEncapsulation, Input, HostBinding } from '@angular/core';
import { Router } from '@angular/router';

import { MenuService } from '@core/bootstrap/menu.service';

@Component({
  selector: 'page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PageHeaderComponent implements OnInit {
  @HostBinding('class') class = 'matero-page-header';

  @Input() nav: string[] = [];

  @Input() showBreadCrumb = true;

  @Input() subtitle = '';

  @Input() title = '';

  constructor(private router: Router, private menu: MenuService) {}

  genBreadcrumb() {
    const states = this.router.url.slice(1).split('/');
    this.nav = this.menu.getMenuLevel(states);
    this.nav.unshift('home');
  }

  ngOnInit() {
    this.nav = Array.isArray(this.nav) ? this.nav : [];

    if (this.nav.length === 0) {
      this.genBreadcrumb();
    }

    this.title = this.title || this.nav[this.nav.length - 1];
  }
}
